import { Container, Grid } from '@material-ui/core'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionTitle } from '../../components/atoms/SectionTittle'
import { CreateEscapeRoomCardView } from '../../components/molecules/CreateEscapeRoomCardView'
import { EscapeRoomCardView } from '../../components/molecules/EscapeRoomCardView'
import { deleteEscapeRoom, getEscapeRooms } from '../../services/escape-room-services'
import { getStartedGames } from '../../services/game-services'
import { invoke, useInvokeEffect } from '../../utils/helper'
import { EscapeRoomHeaderDto, StartedGameDto } from '../../utils/types'

export const EscapeRooms: React.FC = () => {
    const [escapeRooms, setEscapeRooms] = React.useState<EscapeRoomHeaderDto[]>([])
    const [ongoingGames, setOngoingGames] = React.useState<StartedGameDto[]>([])

    const history = useHistory()

    useInvokeEffect(async () => {
        try {
            setOngoingGames(
                await getStartedGames()
            )
        } catch (error) {
            console.log('⚠️ Could not load games:', error)
            setOngoingGames([]) // Set empty array if API fails
        }
        
        try {
            setEscapeRooms(
                await getEscapeRooms()
            )
        } catch (error) {
            console.log('⚠️ Could not load escape rooms:', error)
            setEscapeRooms([]) // Set empty array if API fails
        }
    }, [], {
        operation: 'Liste Escape Rooms',
    })

    const $delete = async (escapeRoom: EscapeRoomHeaderDto) => {
        await invoke(async () => {
            await deleteEscapeRoom(escapeRoom.escapeRoomId)
        }, {
            operation: 'Sletter Escape Room',
            showSuccess: true
        })

        setEscapeRooms(
            escapeRooms.filter((er) => er.escapeRoomId !== escapeRoom.escapeRoomId)
        )
    }

    const amend = async (escapeRoom: EscapeRoomHeaderDto) => {
        history.push({ pathname: '/redigere', state: { escapeRoomId: escapeRoom.escapeRoomId } })
    }

    return (
        <PageWrapper>
            <SectionTitle text="Escape Rooms"/>
            <Container>
                <Grid container>
                    <Grid item xs={12} md={6} lg={4}>
                        <CreateEscapeRoomCardView/>
                    </Grid>

                    {escapeRooms.map((er) => {
                        const startedGame = ongoingGames.find((s) => s.escapeRoom.escapeRoomId === er.escapeRoomId)

                        return (
                            <Grid item xs={12} md={6} lg={4} key={er.escapeRoomId}>
                                <EscapeRoomCardView
                                    escapeRoom={er}
                                    startedGame={startedGame}
                                    onDelete={!er.system && !startedGame ? () => $delete(er) : undefined}
                                    onEdit={!er.system && !startedGame ? () => amend(er) : undefined}/>
                            </Grid>
                        )
                    })}
                </Grid>
            </Container>
        </PageWrapper>
    )
}
